document.querySelectorAll(".email-brilliance-wrapper").forEach(function (element) {
  element.querySelector("form").addEventListener("submit", function (event) {
    event.preventDefault()
    const showError = () => {
      element.querySelector(".subscribe-failure").style.display = "block"
      element.querySelector(".subscribe-success").style.display = "none"
    }

    const showSuccess = () => {
      element.querySelector(".subscribe-failure").style.display = "none"
      element.querySelector(".subscribe-success").style.display = "block"
    }

    let name = element.querySelector("#name").value
    let email = element.querySelector("#email").value

    axios
      .post("/newsletter-signup", {
        name: name,
        email: email,
      })
      .then(function (response) {
        let message = response.data.message
        if (response.body && response.body.csrf_token) {
          document.querySelector("meta[name=csrf-token]").content = response.body.csrf_token
        }
        element.querySelector(".subscribe-success").innerText = message
        showSuccess()
      })
      .catch(function (error) {
        showError()
      })
  })
})
